import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { CountryPOSList } from '../actions/actions.types'

type CountryPosState = ApplicationState['posList']

export function countryPOSReducer(state: CountryPosState = [], action: IAction): CountryPosState {
	switch (action.type) {
		case CountryPOSList.GetCountryPOSList.SUCCESS:
			return action.payload
	}
	return state
}

export default countryPOSReducer
